import React from 'react';
import { motion } from 'framer-motion';
import { Zap, X, Check } from 'lucide-react';
export const PackElite: React.FC = () => {
  return <section className="py-10 md:py-20 bg-gray-50 border-t border-gray-200" data-id="element-250">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251">
        <div className="text-center mb-8 md:mb-16" data-id="element-252">
          <h2 className="text-2xl md:text-4xl font-bold font-serif text-gray-900 mb-2 md:mb-4" data-id="element-253">
            ¿Qué agrega el Pack Élite™?
          </h2>
          <p className="text-base md:text-xl text-primary font-medium" data-id="element-254">
            El sistema para profes que no solo quieren enseñar — quieren crecer
          </p>
        </div>

        <div className="space-y-8 md:space-y-16" data-id="element-255">
          {/* Kit Emprendedora Fit */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl md:rounded-2xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-256">
            <div className="bg-primary p-4 md:p-6 text-center" data-id="element-257">
              <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 text-yellow-400 mb-2 md:mb-4" data-id="element-258">
                <Zap size={20} data-id="element-259" />
              </div>
              <h3 className="text-lg md:text-2xl font-bold font-serif text-white mb-1 md:mb-2" data-id="element-260">
                Kit Emprendedora Fit
              </h3>
              <p className="text-gray-200 text-xs md:text-base" data-id="element-261">
                "Todo para lanzar, vender y escalar tu espacio de telas"
              </p>
            </div>

            <div className="p-0 overflow-x-auto" data-id="element-262">
              <table className="w-full text-left border-collapse" data-id="element-263">
                <thead data-id="element-264">
                  <tr data-id="element-265">
                    <th className="bg-gray-100 p-3 md:p-4 font-bold text-gray-600 border-b border-gray-200 w-1/2 text-xs md:text-base" data-id="element-266">
                      Sin Pack Élite
                    </th>
                    <th className="bg-green-50 p-3 md:p-4 font-bold text-green-800 border-b border-green-200 w-1/2 text-xs md:text-base" data-id="element-267">
                      Con Kit Emprendedora Fit
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100" data-id="element-268">
                  <tr data-id="element-269">
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-600 flex items-start gap-1.5 md:gap-2" data-id="element-270">
                      <X className="text-red-400 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-271" />
                      No sabés cómo fijar tus precios
                    </td>
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-start gap-1.5 md:gap-2" data-id="element-272">
                      <Check className="text-green-600 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-273" />
                      Guía de precios según zona, nivel y modalidad
                    </td>
                  </tr>
                  <tr data-id="element-274">
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-600 flex items-start gap-1.5 md:gap-2" data-id="element-275">
                      <X className="text-red-400 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-276" />
                      No te diferenciás de otras profes
                    </td>
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-start gap-1.5 md:gap-2" data-id="element-277">
                      <Check className="text-green-600 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-278" />
                      Propuesta de valor clara lista para comunicar
                    </td>
                  </tr>
                  <tr data-id="element-279">
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-600 flex items-start gap-1.5 md:gap-2" data-id="element-280">
                      <X className="text-red-400 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-281" />
                      No sabés qué decir por WhatsApp
                    </td>
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-start gap-1.5 md:gap-2" data-id="element-282">
                      <Check className="text-green-600 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-283" />
                      Scripts de venta exactos para cada consulta
                    </td>
                  </tr>
                  <tr data-id="element-284">
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-600 flex items-start gap-1.5 md:gap-2" data-id="element-285">
                      <X className="text-red-400 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-286" />
                      No sabés cómo abrir inscripciones
                    </td>
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-start gap-1.5 md:gap-2" data-id="element-287">
                      <Check className="text-green-600 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-288" />
                      Estrategia de lanzamiento con urgencia real
                    </td>
                  </tr>
                  <tr data-id="element-289">
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-600 flex items-start gap-1.5 md:gap-2" data-id="element-290">
                      <X className="text-red-400 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-291" />
                      No tenés contenido para redes
                    </td>
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-start gap-1.5 md:gap-2" data-id="element-292">
                      <Check className="text-green-600 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-293" />
                      Plantillas de Stories listas para publicar
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </motion.div>

          {/* Programa Anual */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl md:rounded-2xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-294">
            <div className="bg-gray-900 p-4 md:p-6 text-center" data-id="element-295">
              <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 text-accent mb-2 md:mb-4" data-id="element-296">
                <Zap size={20} data-id="element-297" />
              </div>
              <h3 className="text-lg md:text-2xl font-bold font-serif text-white mb-1 md:mb-2" data-id="element-298">
                Programa Anual de Telas: 12 Meses Planificados
              </h3>
              <p className="text-gray-400 text-xs md:text-base" data-id="element-299">
                "Tu año entero de clases organizado, mes por mes"
              </p>
            </div>

            <div className="p-0 overflow-x-auto" data-id="element-300">
              <table className="w-full text-left border-collapse" data-id="element-301">
                <thead data-id="element-302">
                  <tr data-id="element-303">
                    <th className="bg-gray-100 p-3 md:p-4 font-bold text-gray-600 border-b border-gray-200 w-1/2 text-xs md:text-base" data-id="element-304">
                      Sin Pack Élite
                    </th>
                    <th className="bg-green-50 p-3 md:p-4 font-bold text-green-800 border-b border-green-200 w-1/2 text-xs md:text-base" data-id="element-305">
                      Con Programa Anual
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100" data-id="element-306">
                  <tr data-id="element-307">
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-600 flex items-start gap-1.5 md:gap-2" data-id="element-308">
                      <X className="text-red-400 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-309" />
                      No sabés qué enseñar cada mes
                    </td>
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-start gap-1.5 md:gap-2" data-id="element-310">
                      <Check className="text-green-600 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-311" />
                      Objetivos mensuales por nivel definidos
                    </td>
                  </tr>
                  <tr data-id="element-312">
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-600 flex items-start gap-1.5 md:gap-2" data-id="element-313">
                      <X className="text-red-400 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-314" />
                      La progresión es inconsistente
                    </td>
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-start gap-1.5 md:gap-2" data-id="element-315">
                      <Check className="text-green-600 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-316" />
                      Progresión técnica mes a mes estructurada
                    </td>
                  </tr>
                  <tr data-id="element-317">
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-600 flex items-start gap-1.5 md:gap-2" data-id="element-318">
                      <X className="text-red-400 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-319" />
                      No sabés cuándo evaluar
                    </td>
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-start gap-1.5 md:gap-2" data-id="element-320">
                      <Check className="text-green-600 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-321" />
                      Instancias de evaluación y muestra de fin de año
                    </td>
                  </tr>
                  <tr data-id="element-322">
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-600 flex items-start gap-1.5 md:gap-2" data-id="element-323">
                      <X className="text-red-400 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-324" />
                      El recital es un caos
                    </td>
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-start gap-1.5 md:gap-2" data-id="element-325">
                      <Check className="text-green-600 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-326" />
                      Cronograma de shows y clases abiertas listo
                    </td>
                  </tr>
                  <tr data-id="element-327">
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-600 flex items-start gap-1.5 md:gap-2" data-id="element-328">
                      <X className="text-red-400 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-329" />
                      Todo en papelitos sueltos
                    </td>
                    <td className="p-3 md:p-4 text-xs md:text-base text-gray-900 font-medium bg-green-50/30 flex items-start gap-1.5 md:gap-2" data-id="element-330">
                      <Check className="text-green-600 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 mt-0.5" data-id="element-331" />
                      Calendarios y registros listos para completar
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};